<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter" id="toc_id_1">Author's Note on A Bad Day at Duke's East</h1>
<p class="indent">Jamis Arcolin's life has changed since last summer, when he led a quiet, sheltered life in Vérella with his widowed mother and her parents. Now she's Lady Arcolin, Duke Arcolin's wife, and he's Kirgan Arcolin, the duke's heir.  They live in a stronghold in northern Tsaia where he has a pony to ride, meets gnomes from his new father's tribe, horse nomads from the north, soldiers and recruits in training at the stronghold, and children of retired veterans in the nearest village. A summer's day with no lessons, a whole day to spend in the vill playing with friends?  What could be better?</p>
<p class="nonindent1"><span class="small">Publication note: "A Bad Day at Duke's East" is brand new, written exclusively for <em>Deeds of Youth.</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c01_intro.vue?32b0a1eb